import Query from 'components/Query';

export const SnippetCatalog = window.SnippetCatalog || {};

const extendCatalog = catalog => Object.assign(SnippetCatalog, catalog);

const SnippetCatalogQuery = ({catalog, children}) => (
    <Query queryKey={['snippet', 'catalog', catalog]} onSuccess={extendCatalog}>
        {() => children || null}
    </Query>
);

export default SnippetCatalogQuery;
